<crowdctrl-unauthenticated-page
  [pageTitle]="pageTitle"
  [showFooter]="false"
  defaultHref="/about/how-it-works"
>
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle><strong>CrowdCTRL Forms</strong></h1>
      <p crowdctrlUnauthIntroLead>
        Standalone intake for kiosks, QR codes, NFC tags, and session-specific links.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section">
      <p class="about-project__text">
        <strong>CrowdCTRL Forms</strong> is deliberately small and standalone. It works well on a
        self-service tablet kiosk in a corridor or lab entry, and on student phones using a QR code,
        shared URL, or NFC tap for that session. Because it cannot navigate into
        <strong>CrowdCTRL Manager</strong> or the full console in
        <strong>CrowdCTRL Service</strong>, you can leave a tablet out with less worry that someone
        will wander into admin screens.
      </p>
      <p class="about-project__text">
        Staff can share a session- and form-specific link (commonly shown as a QR code) so students
        open the right intake for <em>this</em> class. Where ticket printing is enabled, a QR on a
        receipt can tie back to a particular request. <strong>CrowdCTRL Forms</strong> shows
        students queue position and updates so they can wait until it is their turn.
      </p>
    </section>

    <a
      href="/about/how-it-works"
      class="about-project__back-link"
      (click)="unauthNav.forward($event, '/about/how-it-works')"
      >Back to How it all works</a
    >
  </div>
</crowdctrl-unauthenticated-page>
